import { Controller } from '@hotwired/stimulus'
import { emit } from '../lib/events'

export default class extends Controller {
  static values = { emitable: String, details: Object, onConnect: Boolean }

  connect = () => {
    if (this.onConnectValue) this.sendEvent()
  }

  sendEvent = () => {
    emit(this.emitableValue, {
      bubbles: true,
      detail: this.detailsValue,
    })
  }
}
